<footer [class]="bgClass">
  @if(!isComing) {
  <div class="container">
    <div class="border-white-10">
      <div class="row py-6">
        <div class="col-6 col-sm-4 col-lg-5 mb-7 mb-lg-0">
          <a routerLink="/" class="navbar-brand fw-bold" [class]="textClass">
            <img
              class="img-fluid"
              [src]="
                bgClass === 'bg-white'
                  ? 'assets/icons/icon.png'
                  : 'assets/icons/icon.png'
              "
              alt="Image Description"
            />
            <span>Kreador</span>
          </a>

          <p
            class="fs-16 my-3"
            style="padding-right: 20px"
            [class]="textClass + '-70'"
          >
            Kreador is a technology company that provides <br />
            business and financial services to businesses and individuals.
          </p>
          <br />
          <div class="d-flex gap-3 align-items-center">
            <p class="fs-5 mb-0" [class]="textClass + '-70'">Follow us on:</p>
            <div class="d-flex align-items-center gap-5">
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
              >
                <i class="bi-facebook"></i>
              </a>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
              >
                <i class="bi-twitter-x"></i>
              </a>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
              >
                <i class="bi-slack"></i>
              </a>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
              >
                <i class="bi-linkedin"></i>
              </a>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
              >
                <i class="bi-youtube"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="col-6 col-sm-4 col-lg mb-7 mb-lg-0">
          <span class="text-cap" [class]="textClass">Resources</span>
          <ul class="list-unstyled list-py-1 mb-0">
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
                >Blog</a
              >
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
                >Guidance</a
              >
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
                >Customer Stories</a
              >
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                [routerLink]="'/supports/help'"
                >Support <i class="bi-box-arrow-up-right ms-1"></i
              ></a>
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
                >API</a
              >
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                target="_blank"
                href="https://status.kreador.io/"
                >Status</a
              >
            </li>
          </ul>
        </div>

        <div class="col-6 col-sm-4 col-lg mb-7 mb-lg-0">
          <span class="text-cap" [class]="textClass">Company</span>
          <ul class="list-unstyled list-py-1 mb-0">
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
                >Belonging <i class="bi-box-arrow-up-right ms-1"></i
              ></a>
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
                routerLink="/about-us"
                >Company</a
              >
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                routerLink="/contact-us"
                >Contacts</a
              >
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                routerLink="/resources/security"
                >Security</a
              >
            </li>
          </ul>
        </div>

        <div class="col-6 col-sm-4 col-lg mb-7 mb-sm-0">
          <span class="text-cap" [class]="textClass">Platform</span>

          <ul class="list-unstyled list-py-1 mb-0">
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="https://app.aidefinance.io"
                target="_blank"
                >Web <i class="bi-box-arrow-up-right ms-1"></i
              ></a>
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="https://app.aidefinance.io"
                target="_blank"
                >Mobile <i class="bi-box-arrow-up-right ms-1"></i
              ></a>
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="https://app.aidefinance.io"
                target="_blank"
                >iOS <i class="bi-box-arrow-up-right ms-1"></i
              ></a>
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="https://app.aidefinance.io"
                target="_blank"
                >Android <i class="bi-box-arrow-up-right ms-1"></i
              ></a>
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="https://partners.aidefinance.io"
                target="_blank"
                >Partner <i class="bi-box-arrow-up-right ms-1"></i
              ></a>
            </li>
          </ul>
        </div>

        <div class="col-6 col-sm-4 col-lg mb-7 mb-sm-0">
          <span class="text-cap" [class]="textClass">Legal</span>

          <ul class="list-unstyled list-py-1 mb-5">
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                routerLink="/supports/terms"
                >Terms of use</a
              >
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                routerLink="/supports/terms"
                >Privacy policy
              </a>
            </li>
          </ul>

          <span class="text-cap" [class]="textClass">Docs</span>

          <ul class="list-unstyled list-py-1 mb-0">
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
                >Documentation</a
              >
            </li>
            <li>
              <a
                class="link link-light link-light-75"
                [class]="textClass"
                href="#"
                >Snippets</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  }
  <div
    class="row mx-0 dashed-border-top border-white-10 py-6 align-items-center justify-content-center position-relative overflow-hidden"
  >
    <div class="col-8 position-relative z-index-2">
      <p class="fs-5 mb-0 text-center" [class]="textClass + '-70'">
        Whether you’re tracking business processes, analyzing business data, or
        consolidating accounting process, our platform simplifies personal
        finance management with intelligent insights and tailored
        recommendations. Kreador with registered address in `Unit c13/5 road 3x
        off chevron drive, eti osa LGA, Lagos State, Nigeria `.. <br />Copyright
        © Kreador Inc. 2025.
      </p>
    </div>
    <span class="misc" [class]="textClass">Be smart With Kreador</span>
    <span class="glow"></span>
  </div>
</footer>
